import React from 'react';
import { Fab, Badge, Tooltip, Zoom } from '@mui/material';
import { Chat as ChatIcon, Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useChatbot } from '../../context/ChatbotContext';

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 24,
  zIndex: 1200,
  backgroundColor: theme.palette.success.main,
  color: 'white',
  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
  '&:hover': {
    backgroundColor: theme.palette.success.dark,
    transform: 'scale(1.05)',
    boxShadow: '0 6px 25px rgba(0,0,0,0.2)',
  },
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
}));

const ChatbotButton = () => {
  const { isOpen, openChatbot, closeChatbot, messages } = useChatbot();
  
  // Count unread messages (messages from AI that user hasn't seen)
  const unreadCount = messages.filter(msg => !msg.isUser && !msg.read).length;

  const handleClick = () => {
    if (isOpen) {
      closeChatbot();
    } else {
      openChatbot();
    }
  };

  return (
    <Zoom in={true} timeout={300}>
      <Tooltip 
        title={isOpen ? "Close IMIA" : "Open IMIA"} 
        placement="left"
        arrow
      >
        <StyledFab
          onClick={handleClick}
          size="large"
          aria-label="IMIA Assistant"
        >
          <Badge 
            badgeContent={unreadCount} 
            color="error"
            invisible={unreadCount === 0}
            sx={{
              '& .MuiBadge-badge': {
                right: -3,
                top: -3,
                fontSize: '0.75rem',
                minWidth: '20px',
                height: '20px',
              }
            }}
          >
            {isOpen ? <CloseIcon /> : <ChatIcon />}
          </Badge>
        </StyledFab>
      </Tooltip>
    </Zoom>
  );
};

export default ChatbotButton;
